import FormControl from "../base/FormControl";

export default class InputColor extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "color";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}